import { jsxs as e, jsx as i } from "react/jsx-runtime";
function s({ children: n }) {
  return /* @__PURE__ */ e("div", { className: "relative", children: [
    /* @__PURE__ */ i("div", { className: "inline-spinner", children: " " }),
    n ? /* @__PURE__ */ i("div", { className: "ml-4 align-bottom inline-block leading-8", children: n }) : null
  ] });
}
export {
  s as InlineSpinner
};
